import React, { useState } from 'react';
import { Modal, Button } from 'antd';
import { useDownloadImage } from 'hooks/useDownloadImage';
import SaveDocumentModal from './components/SaveDocumentModal';
import s from './s.module.less';

interface PreviewImageModalProps {
    open: boolean;
    onClose: () => void;
    imageUrl: string;
    fileName?: string;
    fileId?: number;
    needSaveToDocuments?: boolean;
    clientId?: number;
    onSaveSuccess?: () => void;
}

const PreviewImageModal: React.FC<PreviewImageModalProps> = ({
    open,
    onClose,
    imageUrl,
    fileName,
    fileId,
    needSaveToDocuments,
    clientId,
    onSaveSuccess,
}) => {
    const downloadImage = useDownloadImage();
    const [showSaveDocumentModal, setShowSaveDocumentModal] = useState(false);

    const handleDownload = () => {
        if (imageUrl && fileName) {
            downloadImage(imageUrl, fileName);
        }
    };

    const handleSaveToDocuments = () => {
        if (fileId && clientId) {
            setShowSaveDocumentModal(true);
        }
    };

    const handleSaveSuccess = () => {
        setShowSaveDocumentModal(false);
        onSaveSuccess?.();
    };

    return (
        <Modal
            open={open}
            footer={null}
            width="60%"
            centered
            closable={false}
            className={s.imagePreviewModal}
            title={
                <div className={s.imagePreviewHeader}>
                    {needSaveToDocuments && (
                        <Button
                            type="link"
                            className={s.saveToDocumentsBtn}
                            onClick={handleSaveToDocuments}
                        >
                            Save to "Documents"
                        </Button>
                    )}
                    <div className={s.actionIcon} onClick={handleDownload}>
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                            <path d="M4 16L4 17C4 18.6569 5.34315 20 7 20L17 20C18.6569 20 20 18.6569 20 17L20 16M16 12L12 16M12 16L8 12M12 16L12 4" stroke="#111827" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                        </svg>
                    </div>
                    <div className={s.actionIcon} onClick={onClose}>
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                            <path d="M6 18L18 6M6 6L18 18" stroke="#111827" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                        </svg>
                    </div>
                </div>
            }
        >
            <div className={s.imagePreviewContainer}>
                <img
                    src={imageUrl}
                    alt="Preview"
                    className={s.imagePreviewImage}
                />
            </div>
            {fileId && clientId && (
                <SaveDocumentModal
                    open={showSaveDocumentModal}
                    onClose={() => setShowSaveDocumentModal(false)}
                    onSuccess={handleSaveSuccess}
                    fileId={fileId}
                    imageUrl={imageUrl}
                    fileName={fileName}
                    clientId={clientId}
                />
            )}
        </Modal>
    );
};

export default PreviewImageModal;
